import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
// import moment from "moment";
import axios from "axios";
import doctor from "./doctor";
import liff from "@line/liff";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    itemHistoryTaking: {},
    detailConference: {},
    queue: {},
    detailQueue: {},
    appointmentDetail: {},
    itemDrug: [],
    itemHistory: [],
    total: 0,
    detailPhysicalExam: null,
    profile: null,
    login_account: null,
    biz: null,
    role: null,
    statusReady: false,
    detailRefAll: null,
    detailAllGetOneForm: null,
    path: {
      iclaim: "",
      phr: "",
    },
    clinicData: {},
    notiState: {},
    dialogVaccine: false,
    tab: null,
    itemHolyday: [],
    itemsHealth: [],
    healthCheck_notification: [],
    type_notification: [],
    statusPhy_notification: [],
    itemsPermission: [],
    organization: {}, // ข้อมูลองค์กร
    historyTalking: true,
    itemLineOA: {},
    loginWithRedirect: "",
    isCapture: true,
  },
  mutations: {
    setHistoryTaking(state, data) {
      state.itemHistoryTaking = data;
    },
    setItemDrug(state, data) {
      console.log("setItemDrug", data);
      state.itemDrug = data;
    },
    setItemHistory(state, data) {
      state.itemHistory = data;
    },
    setTotal(state, data) {
      state.total = data;
    },
    setCaptureScreen(state, data) {
      state.isCapture = data;
    },
    setAppointmentDetail(state, data) {
      state.appointmentDetail = data;
    },
    setQueueConference(state, data) {
      state.queue = data;
    },
    setDetailConference(state, data) {
      state.detailConference = data;
    },
    setQueueDetail(state, data) {
      state.detailQueue = data;
    },
    setDetailPhysicalExam(state, data) {
      state.detailPhysicalExam = data;
    },
    setProfile(state, data) {
      state.profile = data;
    },
    setRedirect(state, data) {
      state.loginWithRedirect = data;
    },
    setLogin(state, data) {
      state.login_account = data;
    },
    setBiz(state, data) {
      state.biz = data;
    },
    setRole(state, data) {
      state.role = data;
    },
    setStatusReady(state, data) {
      state.statusReady = data;
    },
    setDetailRefAll(state, data) {
      state.detailRefAll = data;
    },
    setDetailAll_GetOneForm(state, data) {
      state.detailAllGetOneForm = data;
    },
    setPath(state, data) {
      state.path = data;
    },
    setClinic(state, data) {
      state.clinicData = data;
    },
    getHolyDay(state, data) {
      state.itemHolyday = data;
    },
    getHealthInfo(state, data) {
      state.itemsHealth = data;
    },
    setOrganization(state, data) {
      state.organization = data;
    },
    setHealthCheck_notification(state, data) {
      state.healthCheck_notification = data;
    },
    setType_notification(state, data) {
      state.type_notification = data;
    },
    setStatusPhysicalExam(state, data) {
      state.statusPhy_notification = data;
    },
    clearStateNotification(state) {
      state.healthCheck_notification = null;
      state.statusPhy_notification = null;
    },
    // clearStatusPhysicalExam(state) {
    //   state.statusPhy_notification = null;
    // },
    clearStateNotificationType(state) {
      state.type_notification = null;
    },
    clearStateLogin(state) {
      state.login_account = null;
    },
    getPermissions(state, data) {
      // sessionStorage.permiss = JSON.stringify(data);
      state.itemsPermission = data;
    },
    getProfileLineOA(state, data) {
      state.itemLineOA = data;
    },
  },
  actions: {
    async getHealthInfoAction({ commit }, payload) {
      const params = new URLSearchParams();
      params.append("page", payload.page || 1);
      params.append("limit", 10);
      // params.append("biz_id", sessionStorage.biz_id);
      params.append("search", payload.one_id);
      console.log("getHealthInfoAction");

      axios
        .get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories/patient?${params}`
        )
        .then((res) => {
          console.log("itemDrug", res);
          const { data: { data, result } = {} } = res;
          if (result == "success") {
            if (data[0]) {
              this.itemDrug = [];
              const { data: searchData, metadata } = data[0];
              const { total } = metadata[0];
              // console.log(total, searchData);
              commit("getHealthInfo", {
                data: searchData,
                totals: total,
              });
              // this.total = total;
              // this.itemHistory = searchData;
            }
          }
          // if ("time_slot_dentist_id" in payload) {
          //   const fillData = data.data.filter((ele) => {
          //     return ele.time_slot_dentist_id == payload.time_slot_dentist_id;
          //   });
          //   data.data = fillData;
          // }

          // commit("getHealthInfo", data);
        });
    },
    async getSharedToken({ commit }) {
      try {
        let one_access_token = "";
        await axios
          .get(
            process.env.VUE_APP_BACKEND_URL +
              `/authorization_v2/v1/getCacheOneAuthorization`
          )
          .then((res) => {
            // console.log('res', res);
            if (res.data.result == "success") {
              one_access_token = res.data.data.one_access_token;
            }
          });
        await axios
          .get(`https://one.th/api/v2/service/shared-token`, {
            headers: {
              Authorization: `Bearer ${one_access_token}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            let shared_token = response.data.data.shared_token;
            let path = {};

            path.phr = "https://fmr.one.th/?shared_token=" + shared_token;
            path.iclaim =
              "https://iclaim.inet.co.th/hospital/?shared_token=" +
              shared_token;
            commit("setPath", path);
          });
      } catch (err) {
        console.log(err);
      }
    },
    HolyDayAction({ commit }) {
      axios
        .get(
          "https://www.googleapis.com/calendar/v3/calendars/th.th%23holiday%40group.v.calendar.google.com/events?key=AIzaSyDNHTIcX859Qc-taUVTwy-rL_YixuiZgbw"
        )
        .then((res) => {
          const { data: { items = [] } = {} } = res;
          commit("getHolyDay", items);
        });
    },
    async getOrganizationAction({ commit }, payload) {
      try {
        const params = new URLSearchParams();
        params.append("biz_id", payload.biz_id);
        await axios
          .get(
            process.env.VUE_APP_BACKEND_URL +
              `/v1/organization/getOrganizationByBizId?${params}`
          )
          .then((res) => {
            const { data: { data } = {} } = res;
            commit("setOrganization", data);
          });
      } catch (error) {
        console.log("organizationAction catch error");
      }
    },
    async getPermissionsAction({ commit }, payload) {
      try {
        const params = new URLSearchParams();
        params.append("biz_id", payload.biz_id);
        params.append("role_name", payload.role_name);
        await axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/role-permission?${params}`
          )
          .then(async (res) => {
            var permission = res.data.data.permission;
            commit("getPermissions", permission);
          });
      } catch (error) {
        console.log("error ~ getPermissionsAction:", error);
      }
    },
    async getProfileLine({ commit }, payload) {
      try {
        await liff.init({ liffId: payload.liffId });
        if (!liff.isLoggedIn()) {
          liff.login();
        } else {
          var profile = await liff.getProfile();
          commit("getProfileLineOA", profile);
          // console.log("profile", profile);
        }
      } catch (error) {
        console.error("LIFF initialization failed", error);
      }
    },
  },
  getters: {
    // getPath: (state) => {
    //   return state.path;
    // },
    setDetailRefAll(state, data) {
      state.detailRefAll = data;
    },
    setDetailAll_GetOneForm(state, data) {
      state.detailAllGetOneForm = data;
    },
    setPath(state, data) {
      state.path = data;
    },
    getQueueDrugGatter: (state) => {
      return state.queueDrug;
    },
    windowWidthGetter: (state) => {
      return state.width;
    },
    getDiagnosticTrackingGetter: (state) => {
      return state.itemDiagnostic;
    },
    permissionsGetter: (state) => {
      return state.itemsPermission;
    },
    queIdGetter: (state) => {
      return state.queId;
    },
    addVaccineGetter: (state) => {
      return state.addvaccine;
    },
    vaccineGetter: (state) => {
      return state.itemsHistoryVaccine;
    },
    getTabGetter: (state) => {
      return state.tab;
    },
    getHealthInfoGetter: (state) => {
      return state.itemsHealth;
    },
    viewHistoryTalkingGetter: (state) => {
      return state.historyTalking;
    },
    setPatientIdGetter: (state) => {
      return state.itemsPatient;
    },
    setMedicalHistoryGetter: (state) => {
      return state.itemsMedicalHistory;
    },
    setHistoryGetter: (state) => {
      return state.itemsHistory;
    },
    currentPatientGetter: (state) => {
      return state.patient_id;
    },
    setReportPaymentListGetter: (state) => {
      return state.reportPaymentList;
    },
    setMedicalCertificatePDFGetter: (state) => {
      return state.medicalCertificatePDF;
    },
    getHolyDayGetter: (state) => {
      return state.itemHolyday;
    },
    organizationGetter: (state) => {
      return state.organization;
    },
  },
  modules: {
    doctor,
  },
  plugins: [createPersistedState()],
});